import { render, staticRenderFns } from "./TextCopy.vue?vue&type=template&id=1db773f4"
import script from "./TextCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./TextCopy.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TextCopy.vue?vue&type=style&index=0&id=1db773f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports